import { useState, useEffect, useCallback } from "react";
import api from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { StatusBadge, PaymentBadge } from "@/pages/MyBookings";
import { PaymentActions } from "@/components/admin/AdminBookings";

export default function AdminCoaching({ onChanged }) {
  const [sessions, setSessions] = useState([]);
  const load = useCallback(() => { api.get("/admin/coaching/sessions").then(r => setSessions(r.data)).catch(() => {}); }, []);
  useEffect(() => { load(); }, [load]);
  const done = () => { load(); onChanged?.(); };

  const sorted = [...sessions].sort((a, b) => (b.date + b.start_time).localeCompare(a.date + a.start_time));

  return (
    <Card className="border-border/50" data-testid="admin-coaching">
      <CardHeader className="pb-3"><CardTitle className="text-lg">Coaching lessons ({sessions.length})</CardTitle></CardHeader>
      <CardContent className="p-0 overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Date</TableHead><TableHead>Time</TableHead><TableHead>Player</TableHead><TableHead>Coach</TableHead><TableHead>Ref</TableHead>
              <TableHead>Payment</TableHead><TableHead>Status</TableHead><TableHead>Price</TableHead><TableHead className="text-right">Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {sorted.map(s => (
              <TableRow key={s._id} data-testid="admin-session-row">
                <TableCell className="text-sm whitespace-nowrap">{s.date}</TableCell>
                <TableCell className="text-sm whitespace-nowrap">{s.start_time}–{s.end_time}</TableCell>
                <TableCell className="text-sm">{s.user_name}{s.notes && <p className="text-[10px] text-muted-foreground max-w-[180px] truncate" title={s.notes}>{s.notes}</p>}</TableCell>
                <TableCell className="text-sm">{s.coach_name}</TableCell>
                <TableCell className="font-mono text-xs">{s.reference}</TableCell>
                <TableCell><PaymentBadge item={s} /></TableCell>
                <TableCell><StatusBadge status={s.status} /></TableCell>
                <TableCell className="font-medium whitespace-nowrap">Rs {Number(s.price).toLocaleString()}</TableCell>
                <TableCell><PaymentActions item={s} testPrefix="session" paidUrl={`/admin/coaching/sessions/${s._id}/mark-paid`} cancelUrl={`/coaching/sessions/${s._id}/cancel`} onDone={done} /></TableCell>
              </TableRow>
            ))}
            {sessions.length === 0 && <TableRow><TableCell colSpan={9} className="text-center text-sm text-muted-foreground py-10">No lessons booked yet.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
